import { FRESHDESK_TICKETS_URL } from "./freshdesk-api-config";
import delivoAxios from "./delivoAxios";
import { getHeaders } from "./DelivoApi";

export const getParams = async ({ query } = {}) => {
  return {
    params: query,
  };
};

export class FreshdeskApi {
  /**
   * Creates a new support ticket
   *
   * @param {CreateSupportTicketRequest} createSupportTicketRequest request
   * @returns {Promise<>}
   */
  async createSupportTicket(createSupportTicketRequest) {
    const headers = await getHeaders("application/json", true, "application/json");

    const response = await delivoAxios.post(
      FRESHDESK_TICKETS_URL,
      {
        type: "post",
        url: "https://delivo.freshdesk.com/api/v2/tickets",
        request_body: JSON.stringify(createSupportTicketRequest),
      },
      { headers },
    );

    if (response?.status !== 201) {
      console.error("Failed to create freshdesk ticket.", createSupportTicketRequest, response);
      throw new Error(`Failed to create freshdesk ticket: ${createSupportTicketRequest}`);
    }
  }

  /**
   * Gets all support tickets for the user
   *
   * @param {GetSupportTicketsRequest} getSupportTicketsRequest request
   * @returns {Promise<>}
   */
  async getSupportTickets(getSupportTicketsRequest) {
    const headers = await getHeaders("application/json", true, "application/json");

    const response = await delivoAxios.post(
      FRESHDESK_TICKETS_URL,
      {
        type: "get",
        url: `https://delivo.freshdesk.com/api/v2/tickets?email=${getSupportTicketsRequest.email}`,
        request_body: "123",
      },
      { headers },
    );

    if (response?.status !== 200) {
      console.error("Failed to get freshdesk tickets.", getSupportTicketsRequest, response);
      throw new Error(`Failed to get freshdesk tickets: ${getSupportTicketsRequest}`);
    }
    return response.data;
  }
}

const freshdeskApi = new FreshdeskApi();
export { freshdeskApi };
